import * as React from 'react';
import { ShippingLineIcon, ShippingLineLabel, ShippingLineText } from './helpers/styles';
import { faPeopleCarry } from '@fortawesome/pro-duotone-svg-icons/faPeopleCarry';
import { FormattedMessage } from 'react-intl';
import { getCatalog } from '@/redux/modules/catalog';
import { getCatalogDetail } from '@/redux/modules/catalogDetail';
import isEqual from 'react-fast-compare';
import { useSelector } from 'react-redux';

type Props = {
    catalogId: number;
};

const LocalPickupLine = ({ catalogId }: Props) => {
    const { address: catalogAddress } = useSelector((state) => getCatalog(state, catalogId), isEqual);
    const { freeLocalPickup } = useSelector((state) => getCatalogDetail(state, catalogId));
    const { city, country, fullCountryName, state } = catalogAddress;

    // If a catalog address is invalid, hide line
    if (freeLocalPickup && !country) {
        return null;
    }

    return (
        <>
            <ShippingLineIcon icon={faPeopleCarry} />
            <ShippingLineLabel>
                <FormattedMessage
                    id={
                        freeLocalPickup
                            ? 'shippingInfo.localPickup.localPickupLabel'
                            : 'shippingInfo.localPickup.localPickupNotAvailableLabel'
                    }
                />
            </ShippingLineLabel>
            {freeLocalPickup && (
                <ShippingLineText>
                    <FormattedMessage
                        id={state ? 'shippingInfo.shippingLocation' : 'shippingInfo.shippingLocationNoState'}
                        values={{
                            city,
                            country: fullCountryName,
                            ...(state ? { state: state.toUpperCase() } : {}),
                        }}
                    />
                </ShippingLineText>
            )}
        </>
    );
};

export default React.memo<Props>(LocalPickupLine);
